module.exports = __webpack_public_path__ + "e7c4f452b860bb7202b8363feb0e1f73.pdf";